// import { Video } from '../../stores/program/model/Program';
import HomePageEvents from "./HomePageEvents";
import { RecommendVideo, UserVideo, VerticalList } from "./model/HomePage";

// -----------------------------------------------------------------------------------
// おすすめビデオ
// 取得
export const GetRecVideoList = (userId: string) =>
    ({
        type: HomePageEvents.GetRecVideoListStarted,
        userId,
    } as const);
export const GetRecVideoListComplete = (videos: RecommendVideo[]) =>
    ({
        type: HomePageEvents.GetRecVideoListComplete,
        videos,
    } as const);

// 編集
export const UpdateRecVideos = (videos: string[], userId: string) =>
    ({
        type: HomePageEvents.UpdateRecVideosStarted,
        videos,
        userId,
    } as const);
export const UpdateRecVideosComplete = (recommendVideoList: RecommendVideo[]) =>
    ({
        type: HomePageEvents.UpdateRecVideosComplete,
        recommendVideoList,
    } as const);
export const UpdateRecVideosFailed = () =>
    ({
        type: HomePageEvents.UpdateRecVideosFailed,
    } as const);
// 追加
export const AddVideoToRec = (videoId: string) =>
    ({
        type: HomePageEvents.AddVideoToRecStarted,
        videoId,
    } as const);
export const AddVideoToRecComplete = (recommendVideoList: RecommendVideo[]) =>
    ({
        type: HomePageEvents.AddVideoToRecComplete,
        recommendVideoList,
    } as const);

// 削除
export const DelVideoFromRec = (videoId: number) =>
    ({
        type: HomePageEvents.DelVideoFromRecStarted,
        videoId,
    } as const);
export const DelVideoFromRecComplete = (recommendVideoList: RecommendVideo[]) =>
    ({
        type: HomePageEvents.DelVideoFromRecComplete,
        recommendVideoList,
    } as const);

// -----------------------------------------------------------------------------------
// おすすめプログラム
// 取得
export const GetRecommendProgramList = (userId: string) =>
    ({
        type: HomePageEvents.GetRecommendProgramListStarted,
        userId,
    } as const);
export const GetRecommendProgramListComplete = (recommendProgramList: VerticalList[]) =>
    ({
        type: HomePageEvents.GetRecommendProgramListComplete,
        recommendProgramList,
    } as const);
// 編集
export const UpdateRecPrograms = (programs: string[], userId: string) =>
    ({
        type: HomePageEvents.UpdateRecProgramsStarted,
        programs,
        userId,
    } as const);
export const UpdateRecProgramsComplete = (recommendProgramList: VerticalList[]) =>
    ({
        type: HomePageEvents.UpdateRecProgramsComplete,
        recommendProgramList,
    } as const);
export const UpdateRecProgramsFailed = () =>
    ({
        type: HomePageEvents.UpdateRecProgramsFailed,
    } as const);
// 追加
export const addRecProgram = (id: number, userId: string) =>
    ({
        type: HomePageEvents.addRecProgramStarted,
        id,
        userId,
    } as const);
export const addRecProgramComplete = (recommendProgramList: VerticalList[]) =>
    ({
        type: HomePageEvents.addRecProgramComplete,
        recommendProgramList,
    } as const);
// 削除
export const delRecProgram = (id: number, userId: string) =>
    ({
        type: HomePageEvents.delRecProgramStarted,
        id,
        userId,
    } as const);
export const delRecProgramComplete = (recommendProgramList: VerticalList[]) =>
    ({
        type: HomePageEvents.delRecProgramComplete,
        recommendProgramList,
    } as const);

// -----------------------------------------------------------------------------------
// おすすめプロフェショナル
// 取得
export const GetRecommendProfessionalList = (userId: number) =>
    ({
        type: HomePageEvents.GetRecommendProfessionalListStarted,
        userId,
    } as const);
export const GetRecommendProfessionalListComplete = (recommendProfessionalList: VerticalList[]) =>
    ({
        type: HomePageEvents.GetRecommendProfessionalListComplete,
        recommendProfessionalList,
    } as const);
// 編集
export const UpdateRecProfessionals = (professionals: string[]) =>
    ({
        type: HomePageEvents.UpdateRecProfessionalsStarted,
        professionals,
    } as const);
export const UpdateRecProfessionalsComplete = (recommendProfessionalList: VerticalList[]) =>
    ({
        type: HomePageEvents.UpdateRecProfessionalsComplete,
        recommendProfessionalList,
    } as const);
export const UpdateRecProfessionalsFailed = () =>
    ({
        type: HomePageEvents.UpdateRecProfessionalsFailed,
    } as const);
// 追加
export const addRecProfessional = (id: number) =>
    ({
        type: HomePageEvents.addRecProfessionalStarted,
        id,
    } as const);
export const addRecProfessionalComplete = (recommendProfessionalList: VerticalList[]) =>
    ({
        type: HomePageEvents.addRecProfessionalComplete,
        recommendProfessionalList,
    } as const);
// 削除
export const removeRecProfessional = (id: number, userId: number) =>
    ({
        type: HomePageEvents.removeRecProfessionalStarted,
        id,
        userId,
    } as const);

export const removeRecProfessionalComplete = (recommendProfessionalList: VerticalList[]) =>
    ({
        type: HomePageEvents.removeRecProfessionalComplete,
        recommendProfessionalList,
    } as const);

export const removeRecProfessionalFailed = (recommendProfessionalList: VerticalList[]) =>
    ({
        type: HomePageEvents.removeRecProfessionalFailed,
        recommendProfessionalList,
    } as const);

// -----------------------------------------------------------------------------------
// 新着ビデオ
// 取得
export const GetNewVideoList = (userId: string) =>
    ({
        type: HomePageEvents.GetNewVideoListStarted,
        userId,
    } as const);

export const GetNewVideoListComplete = (newVideoList: UserVideo[]) =>
    ({
        type: HomePageEvents.GetNewVideoListComplete,
        newVideoList,
    } as const);

// -----------------------------------------------------------------------------------
// ユーザー視聴履歴
// 取得
export const GetVideoListByUser = (userId: string) =>
    ({
        type: HomePageEvents.GetVideoListByUserStarted,
        userId,
    } as const);

export const GetVideoListByUserComplete = (userVideos: UserVideo[]) =>
    ({
        type: HomePageEvents.GetVideoListByUserComplete,
        userVideos,
    } as const);

export const ResetUserVideos = () =>
    ({
        type: HomePageEvents.ResetUserVideos,
    } as const);
